import { render, staticRenderFns } from "./PublishPacket.vue?vue&type=template&id=00972670&"
import script from "./PublishPacket.vue?vue&type=script&lang=js&"
export * from "./PublishPacket.vue?vue&type=script&lang=js&"
import style0 from "./PublishPacket.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports